
import {
  getAllRole,
  upDataUser,
  addUser,
  getUserDetails
} from "@/api/api-basic";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import validate from "@/common/regular";
import sha256 from "js-sha256";
import i18n from "@/config/i18n";
@Component
export default class SystemConfigUserAdd extends Vue {
  private modalShow = false;
  private getLoading = false;
  private isQuery = false;
  private loading = true;
  private roleList: objAny[] = [];
  private isAdd = false;
  private FormData: objAny = {};
  private modalTitle = i18n.t("user.addUser");
  /**
   * 新增表单验证
   */
  private ruleInline: objAny = {
    fullName: [
      {
        required: true,
        validator: validate.name,
        name: i18n.t("user.fullName"),
        trigger: "blur",
        max: 50
      }
    ],
    userName: [
      {
        required: true,
        validator: validate.name,
        name: i18n.t("user.userName"),
        trigger: "blur"
      }
    ],
    userRoleId: [
      { required: true, message: i18n.t("user.userRolePl"), trigger: "change" }
    ],
    phone: [
      {
        required: true,
        validator: validate.tel,
        trigger: "blur"
      }
    ],
    userPwd: [
      {
        required: true,
        trigger: "blur",
        validator: (rule: objAny, value: string) => {
          const regText = /\s+/;
          if (!value) {
            return new Error(i18n.t("user.userPwdNull") + "");
          } else if (value.trim().length < 6 || value.trim().length > 18) {
            return new Error(i18n.t("user.userPwdMin") + "");
          } else if (regText.test(value)) {
            return new Error(i18n.t("user.userPwdError") + "");
          }
          return true;
        }
      }
    ],
    confirmPassword: [
      {
        required: true,
        trigger: "blur",
        validator: (rule: objAny, value: string) => {
          if (!value) {
            return new Error(i18n.t("user.userPwdNull") + "");
          } else if (value !== this.formItem.userPwd) {
            return new Error(i18n.t("user.userPwdTowError") + "");
          }
          return true;
        }
      }
    ]
  };
  private formItem: objAny = {
    phone: "",
    fullName: "",
    userName: "",
    userRoleId: "",
    userId: "",
    userPwd: "",
    confirmPassword: ""
  };
  private itemData: objAny = {};

  public open(item: objAny, type: string) {
    if (!this.FormData.$el) {
      this.$nextTick((): void => {
        this.FormData = this.$refs["formItem"];
      });
    } else {
      this.handleReset();
    }

    this.modalShow = true;
    this.loading = true;
    if (type === "query") {
      this.isQuery = true;
    } else {
      this.isQuery = false;
    }
    this.roleList = [];
    if (type === "add") {
      this.isAdd = true;
      this.formItem.phone = "";
      this.formItem.fullName = "";
      this.formItem.userName = "";
      this.formItem.userRoleId = "";
      this.formItem.userId = "";
      this.formItem.userPwd = "";
      this.formItem.confirmPassword = "";
      this.modalTitle = i18n.t("user.addUser");
      this.getRoleSelect();
    } else {
      this.isAdd = false;
      this.getUserDetails(item.userPkId);
      this.modalTitle = this.isQuery
        ? i18n.t("user.queryUser")
        : i18n.t("user.upUser");
    }
  }

  public handleSubmit(): void {
    this.loading = true;
    (this.$refs["formItem"] as objAny).validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      } else {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      }
    });
  }
  public closeModal(): void {
    this.modalShow = false;
  }
  public handleReset() {
    this.FormData.resetFields();
  }
  async submitData(): Promise<void> {
    let ret: objAny;
    const params: objAny = {
      fullName: this.formItem.fullName,
      rolePkId: this.formItem.userRoleId,
      userName: this.formItem.userName,
      phone: this.formItem.phone,
      userPwd: this.formItem.userPwd,
      remark: this.formItem.remark
    };
    const json: objAny = JSON.parse(JSON.stringify(params));
    json.userPwd = sha256.sha256(json.userPwd);

    if (this.formItem.userId === "") {
      ret = await addUser(json);
    } else {
      json.userPkId = this.formItem.userId;
      ret = await upDataUser(json);
    }
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
    // this.loading = false;
  }
  async getRoleSelect(): Promise<void> {
    const json: objAny = {};
    if (!this.isAdd) {
      json.roleType = this.itemData.roleType;
    }
    const ret = await getAllRole(json);
    const list: objAny[] = [];
    if (ret.status === this.$config.apiStatus) {
      ret.data.map((item: objAny) => {
        if (
          (this.isAdd && item.roleType === 1) ||
          (this.isAdd && item.roleType === 6)
        ) {
          list.push(item);
        } else {
          list.push(item);
        }
      });
      this.roleList = list;
    }
  }
  async getUserDetails(userId: string): Promise<void> {
    const ret = await getUserDetails({ userPkId: userId });
    if (ret.status === this.$config.apiStatus) {
      const item = ret.data[0] || [];
      this.itemData = item;
      this.formItem.phone = item.phone;
      this.formItem.fullName = item.fullName;
      this.formItem.userName = item.userName;
      this.formItem.userId = item.userPkId;
      this.formItem.userRoleId = item.rolePkId;
      this.getRoleSelect();
    }
  }
  mounted() {
    this.$emit("getChild", this);
  }
}
